import React from 'react';
import { Card, Typography, Button, Image, Grid, Divider } from 'antd';
import '../../../Styles/Linkages&Outreach.css'; // Custom styles
import image from '../../../Assets/Linkages/Collaborations-AI.png'
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;


const LinkagesCollaborations = () => {
  const screens = useBreakpoint();

  return (
    <div className="linkages-collaborations-container">
      <Card className="linkages-collaborations-card" bordered={false} bodyStyle={{ padding: '40px' }}>
        <div className="content-wrapper">
          <div className="image-section">
            <Image
              preview={false}
              src={image} 
              alt="Global academic, research and industry collaboration network"
              className="collaborations-image"
            />
          </div>
          <div className="text-section">
            <Title level={2} className="section-title">
Collaborations
            </Title>
            <Divider className="ncgsa-divider" />
            <Paragraph  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} className="description">
              
NCGSA is committed to forging strategic partnerships that drive innovation in space science, technology, and applications. By collaborating with a distinguished network of national and international academic institutions, industry pioneers, and research organizations, NCGSA advances a commitment to excellence and cultivates enduring, mutually advantageous relationships within the realms of Geographic Information Systems (GIS) and space applications.
            </Paragraph>
            <Link to="/collaborations">
              <Button className="view-all-btn" type="primary" shape="round">
                View All
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LinkagesCollaborations;
